import React from 'react';
import { add } from '../Services/Cart.service';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import withReactiveStyleBuyButton from '../Containers/withReactiveStyleBuyButton';
import { connect, useDispatch } from 'react-redux';

const getCart = async ({ articleNumber, quantity }) =>
  await add({
    articleNumber,
    quantity,
  });
//onError required for withReactiveStyleBuyButton
const ReorderOrderLineButton = ({
  title,
  onClick,
  label,
  articleNumber,
  quantity,
  cssClass,
  onSuccess,
  onError,
}) => (
  <button
    type="button"
    className={cssClass}
    onClick={() =>
      onSuccess(
        onClick({
          articleNumber,
          quantity,
        })
      )
    }
    title={title}
  >
    {label}
  </button>
);

const mapDispatchToProps = (dispatch) => ({
  onSuccess: (cart) => dispatch(receive(cart)),
  onError: (ex) => dispatch(catchError(ex, (error) => loadError(error))),
});

export default connect(
  null,
  mapDispatchToProps
)(
  withReactiveStyleBuyButton(
    ReorderOrderLineButton,
    getCart,
    'buy-button-container'
  )
);
